import React from 'react';
import ArticleCard from './ArticleCard'; // Adjust path
import { commonStyles, layout } from '../styles/minimalStyles';
import AnimateOnScroll from '../../Components/AnimateOnScroll';
const styles = {
  featuredGrid: {
    display: 'grid',
    gap: layout.gap,
    gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', // Default grid
     // Note: More complex layouts (like first item spanning columns) are hard
     // without CSS or libraries. This keeps it simpler grid.
     // For the original layout, you'd need JS to detect screen size or use a library.
  },
   // Style for first article wrapper if needed, but simple grid might be sufficient
  // firstArticleWrapper: {
  //   gridColumn: '1 / -1', // Span full on mobile (implicitly by auto-fill)
  //   '@media (min-width: 992px)': { // This won't work in inline styles!
  //      gridColumn: '1 / span 2',
  //      gridRow: '1 / span 2',
  //    }
  // },
};


const FeaturedArticles = ({ articles, onArticleClick }) => {
  if (!articles || articles.length === 0) {
    return null;
  }

  // Simplified: Render all featured articles in the grid.
  // The first might use 'featured-large' layout from ArticleCard for differentiation.
  const firstArticle = articles[0];
  const otherArticles = articles.slice(1);


  return (
    // <AnimateOnScroll> // Removed for simplicity with inline styles
    <AnimateOnScroll>
      <section style={{...commonStyles.container, ...commonStyles.section}}>
        <h2 style={commonStyles.sectionTitle}>Latest News</h2>
        <div style={styles.featuredGrid}>
           {firstArticle && (
               <ArticleCard
                key={firstArticle.id}
                article={firstArticle}
                onClick={onArticleClick}
                layout="featured-large" // Differentiate the first card
              />
           )}
           {otherArticles.map((article) => (
             <ArticleCard
              key={article.id}
              article={article}
              onClick={onArticleClick}
              layout="grid" // Standard layout for others
            />
          ))}
        </div>
      </section>
    </AnimateOnScroll>
  );
};

export default FeaturedArticles;